<template>
  <div>
    <!--在线用户 -->
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      @searchSubmit="searchSubmit"
      @handleSelectionChange="handleSelectionChange"
      @refresh-change="getlist"
      @refreshBtn="refreshBtn"
    ></zx-table>
  </div>
</template>
<script>
import * as online from "@/api/online/online.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [1, 3, 10, 20, 30, 40, 50, 100],
        // sizes, prev, pager, next, jumper, ->, total, slot
        // "layout":"prev, pager, next",
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "参数",
        // 表格底部按钮
        btnBottom: false,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        // selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: false,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          {
            prop: "login_name",
            label: "用户名称",
            nowrap: true,
            type: "input",
            hide: true
          },
          {
            prop: "dept_name",
            label: "所属部门",
            type: "input",
            hide: true
          },
          {
            prop: "ipaddr",
            label: "登录IP",
            nowrap: true,
            type: "input",
            hide: true
          },
          {
            prop: "login_date",
            label: "登录时间",
            nowrap: true,
            type: "input",
            hide: true
          },
          {
            prop: "login_location",
            label: "登录地点",
            nowrap: true,
            type: "input",
            hide: true
          },
          {
            prop: "browser",
            label: "浏览器",
            nowrap: true,
            type: "input",
            hide: true
          },
          {
            prop: "os",
            label: "操作系统",
            nowrap: true,
            type: "input",
            hide: true
          }
        ],
        btnList: [
          {
            name: "强退",
            type: "text",
            click: (id, row, index) => {
              // row.sessionId
              this.$confirm("是否将此用户强退?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(() => {
                online.offlineUser.r({ sessionId: row.sessionId }).then(res => {
                  console.log("成功");
                  this.$message({
                    type: "success",
                    message: "强退成功!"
                  });
                  this.getlist();
                });
              });
            }
          }
        ],
        btnNavLeft: [
          {
            text: "全部强退",
            size: "mini",
            type: "warning",
            click: (id, row, index) => {
              // row.sessionId
              this.$confirm("是否将全部用户强退?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(() => {
                online.offlineUserAll.r().then(res => {
                  console.log("成功");
                  this.$message({
                    type: "success",
                    message: "强退成功!"
                  });
                  this.getlist();
                });
              });
            }
          }
        ]
      },
      tableData: []
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    //   多选
    handleSelectionChange(e) {},
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 分页器
    refreshChange(e) {
      let that = this;
      setTimeout(() => {
        this.getlist();
      }, 1000);
    },
    getlist(e) {
      let param;
      let that = this;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      online.getOnlineList.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    }
  }
};
</script>
